export default __webpack_public_path__ + "static/media/app-bar-login.c3209f5a.svg";